export default __webpack_public_path__ + "static/media/delete.80632404.svg";